import { BreadcrumbProps } from 'bd-web-components/dist/components/Breadcrumb'
import { Breadcrumb as BreadcrumbComponent } from 'bd-web-components'
import useBdApp from '../../hooks/bdapp/useBdApp'

export const Breadcrumb = (props: BreadcrumbProps) => {
  const { isNative } = useBdApp()

  if (isNative) {
    return null
  }

  return <BreadcrumbComponent {...props} />
}
